import _ from 'lodash'
import * as React from 'react'
import { Box } from '@mui/material'
import { useDispatch } from 'react-redux'
import { infoOptions } from '../../utils'
import { updateFilterListByID } from '../../redux/slices/Search/input'
import Container from './Container'
import Selector from '../Selector'

const SelectorFilter = ({
  w,
  WIDTHMIN,
  boxGrew,
  options,
  toFilter,
  children,
  ...rest
}) => {
  const DIMENSION = 750
  const dispatch = useDispatch()
  const placeholder = infoOptions?.[rest.type]?.name

  const handleChangeOptions = e => {
    const element = _.filter(options, { id: e.target.value })
    const someValue = { ...toFilter, filterList1: element, filterList2: [] }
    dispatch(updateFilterListByID({ someId: rest.idx, someValue }))
  }

  const handleChangeOptions2 = e => {
    const element = _.filter(rest.filterList1[0].options, ['id', e.target.value])
    const someValue = { ...toFilter, filterList2: element }
    dispatch(updateFilterListByID({ someId: rest.idx, someValue }))
  }

  const isSingleSelect = _.includes(['sitetype', 'zonetype'], rest.type)

  const styleContainer = !isSingleSelect
    ? { flexDirection: rest.windowWidth >= WIDTHMIN ? 'row' : 'column' }
    : {}

  const styleSelectorBox = {
    width: '100%',
    display: 'flex',
    flexDirection: rest.windowWidth < DIMENSION ? 'column' : 'row',
    maxWidth:
      rest.windowWidth <= WIDTHMIN
        ? '100%'
        : rest.idx === rest.lengthList
        ? 'calc(100% - 72px)'
        : 'calc(100% - 36px)',
  }

  return (
    <Container style={styleContainer} isRow={rest.windowWidth > WIDTHMIN} w={w}>
      <Box sx={styleSelectorBox}>
        <Selector
          name={`select-${rest.type}-${rest.filterList1?.[0]?.id}`}
          value={rest.filterList1?.[0]?.id ?? ''}
          onChange={handleChangeOptions}
          opts={options}
          placeholder={placeholder}
          sxBox={{
            width: '100%',
            minWidth: rest.windowWidth <= WIDTHMIN ? '100%' : '230px',
          }}
        />
        {!isSingleSelect && Boolean(rest.filterList1?.length) ? (
          <Selector
            name={`select2-${rest.type}-${rest.filterList2?.[0]?.id}`}
            value={rest.filterList2?.[0]?.id ?? ''}
            onChange={handleChangeOptions2}
            opts={_.find(options, ['id', rest.filterList1[0].id]).options}
            placeholder={placeholder}
            sxBox={{
              width: '100%',
              pt: rest.windowWidth < DIMENSION ? 1 : 0,
              pl: rest.windowWidth < DIMENSION ? 0 : 1,
            }}
          />
        ) : null}
      </Box>
      {children}
    </Container>
  )
}

export default SelectorFilter
